/**
 * A site as the screens that load every site at once use it 
 * * the invite multiselect
 * * the site map
 * * the user site-details table. 
 * 
 * Returned by `GET /api/ext-site/for-dropdowns`, which replaced a `size=99999` page of full site payloads.
 */
export class SiteDropdownItem {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  siteOwner: SiteDropdownItemOwner;
  siteType: SiteDropdownItemType;

  /**
   * Present only when the site has an induction course; most screens test it for existence.
   * The user site-details induction reminder also reads its name, to preview the email being sent.
   */
  siteInductionCourse: SiteDropdownItemCourse;

  public deserialize(input: any): this {
    this.id = input.id;
    this.name = input.name;
    this.latitude = input.latitude;
    this.longitude = input.longitude;
    this.siteOwner = input.siteOwner;
    this.siteType = input.siteType;
    this.siteInductionCourse = input.siteInductionCourse;

    return this;
  }
};

export interface SiteDropdownItemOwner {
  /** SkylarkUser id, what the owner filters on these screens compare against. */
  id: number;
  name: string;
}

export interface SiteDropdownItemType {
  id: number;
  name: string;
}

export interface SiteDropdownItemCourse {
  id: number;
  name: string;
}
